export default function visit (node, visitors) {
  const visitor = visitors[node.type]

  node = visitor ? visitor(node) : node

  if (!node) {
    return
  }

  switch (node.type) {
    case 'element':
    case 'document':
    case 'fragment':
      node.children = node.children.map(c => visit(c, visitors))
  }

  return node
}
